import { createSlice, PayloadAction } from "@reduxjs/toolkit";
interface PharmacyDropDown {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  PharmacyDropDownData?: any;
}
let initialState: PharmacyDropDown = {
  isLoading: false,
  error: false,
  message: null,
  PharmacyDropDownData: [],
};
const PharmacyDropDownSlice = createSlice({
  name: "PharmacyDropDown",
  initialState,
  reducers: {
    loadingPharmacyDropDown: (
      state: PharmacyDropDown,
      action: PayloadAction
    ) => {
      state.isLoading = true;
    },
    setPharmacyDropDown: (
      state: any,
      action: PayloadAction<PharmacyDropDown>
    ) => {
      return action.payload;
    },
    clearData: (state: PharmacyDropDown, action: PayloadAction) => {
      state.error = false;
    },
  },
});

export const { loadingPharmacyDropDown, setPharmacyDropDown, clearData } =
  PharmacyDropDownSlice.actions;

export default PharmacyDropDownSlice.reducer;
